import { animated } from "@react-spring/native";
import styled from "styled-components/native";
import { margin } from "styled-system";

export const StyledAnimatedContainer = styled(animated.View)`
  ${margin}
  width: 100%;
  height: 100%;
`;
